<!-- template>
  <div class="home">
    <v-layout row>
      <v-flex xs12>
        <v-card hover raised>
          <v-responsive height="300px" class="pa-5 red lighten-1">
            <div class="display-1 white--text text-xs-center">{{msg}}</div>
          </v-responsive>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template -->
<template>
        <v-card
          class="mx-auto mt-20"
          elevation="10"
          max-width="550"
        >
          <!-- v-responsive height="300px" class="pa-5 red lighten-1">
            <div class="display-1 white--text text-xs-center">{{msg}}</div>
          </v-responsive -->
          <v-card-title class="red lighten-1">
            <div class="headline"><v-icon class="mr-2">fas fa-exclamation-triangle</v-icon><span>404 Not found</span></div>
          </v-card-title>
          <v-card-text>
            <div class="title pt-5 pb-5">{{msg}}</div>
          </v-card-text>
        </v-card>
</template>

<script>
export default {
  name: 'ErrorPage',
  data () {
    return {
      msg: 'Sorry, the page you\'re looking for doesn\'t exist.'
    }
  }
}
</script>
